/* eslint-disable prettier/prettier */
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  TextField,
  Toolbar,
  Typography
} from '@material-ui/core'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import { selectedChatReducer } from 'src/store/reducers/chatReducer';
import { Link, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { setChats, setSelectedChat } from 'src/store/actions/chatActions'
import { API_URL, JWT_TOKEN } from '../../../../config'
import image1 from './images/image1.jpg'
// import Cookies from 'js-cookie'

const useStyles = makeStyles((theme) => ({
  component: {
    background: '#FFF',
    color: 'black',
  },
  container: {
    justifyContent: 'center',
    '& > *': {
      padding: 20,
    },
  },
  box: {
    marginTop: '64px',
    padding: '0 100px',
  },
  image: {
    width: '100%',
    height: '50vh',
    background: 'center',
    borderRadius: '10px',
    objectFit: 'cover',
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  heading: {
    fontSize: 38,
    fontWeight: 600,
    testAlign: 'center',
    margin: '50px 0 10px 0 ',
  },
  subheading: {
    color: '#a7a7a7',
    display: 'flex',
    justifyContent: 'space-between',
  },
  userDet: {
    display: 'flex',
  },
  button: {
    backgroundColor: '#f4bb44',
    border: 'none',
    color: 'white',
    width: 100,
    height: 60,
    marginTop: 70,
  },
  button2: {
    backgroundColor: 'white',
    border: '1px solid #f4bb44',
    color: '#f4bb44',
    width: 100,
    height: 60,
    marginTop: 70,
  },
  button3: {
    backgroundColor: '#f4bb44',
    border: 'none',
    color: 'white',
    width: 100,
    height: 50,
  },
  button4: {
    backgroundColor: 'white',
    border: '1px solid #f4bb44',
    color: '#f4bb44',
    width: 100,
    height: 50,
  },
  username: {
    paddingTop: 10,
    paddingLeft: 10,
  },
}))

const Info = () => {
  const classes = useStyles()
  const [showDialog, setShowDialog] = useState(false)
  let { id } = useParams()
  const [question, setQuestion] = useState('')
  const [date, setDate] = useState('')
  const [answers, setAnswers] = useState([])
  const [username, setUsername] = useState('')
  // const [points, setPoints] = useState('')
  // const [rewards, setRewards] = useState('')
  const [task_ans, setTaskAns] = useState('')
  const [userId, setUserId] = useState('')
  const dispatch = useDispatch()
  // const history = useHistory()
  const chats = useSelector((state) => state.chats.chats)
  
  // const login = useSelector(state => state.login);

  const viewTask = async () => {
    try {
      let config = {
        headers: { 'X-Auth-Token': JWT_TOKEN },
        params: { id: id },
      }

      const response = await axios.get(API_URL.view_task_api, config)
     // console.log("VIEW TASK",response.data)
      setQuestion(response.data?.message?.question)
      setDate(response.data?.message?.created_date)
      setUsername(response.data?.message?.created_by)
      // setPoints(response.data?.message?.points)
      // setRewards(response.data?.message?.rewards)
      console.log('view task', response.data)
    } catch (error) {
      console.log(error)
    }
  }

  const fetchUserID = async () => {
    try {
      let config = {
        headers: { 'X-Auth-Token': JWT_TOKEN },
        params: {
          user: username,
        },
      }
      const res = await axios.get(API_URL.fetch_user_api, config)
      setUserId(res.data?.message?._id)
     // console.log('fetch user id', res.data)
    } catch (error) {
      console.log(error)
    }
  }

  

  const submitAns = async (e) => {
    e.preventDefault()
    try {
      const newObj = {
        task_answer: task_ans,
      }
      let config = {
        headers: { 'X-Auth-Token': JWT_TOKEN },
        params: { id: id },
      }
      const response = await axios.post(API_URL.submit_answer_api, newObj, config)
      //console.log(response);
      if (response.data.status) {
        closeDialog()
        toast.success(response.data.message, {
          position: 'top-center',
          autoClose: 5000,
          pauseOnHover: false,
        })
      } else {
        toast.error(response.data.message, {
          position: 'top-center',
          autoClose: 5000,
          pauseOnHover: false,
        })
      }
      setTaskAns('')
    } catch (error) {
      console.log(error)
    }
  }

  const fetchAnswer = async () => {
    try {
      let config = {
        headers: { 'X-Auth-Token': JWT_TOKEN },
        params: { id: id },
      }
      const response = await axios.get(API_URL.view_all_answer_creator, config)
      //   console.log(response.data.data.answers)
      setAnswers(response.data.data && response.data.data.answers)
    } catch (error) {
      console.log(error)
    }
  }

  const fetchChats = async () => {
    try {
    
      let config = {
        headers : {'X-Auth-Token' : localStorage.getItem('jwt_token')}
      }
      const {data} = await axios.get('http://localhost:7000/secure/chat',config)
      //console.log("FETCH CHATS",data)
      dispatch(setChats(data.message))
    } catch (error) {
      console.log(error)
    }
  }


  const accessChat = async() =>{
   
    try {
      
          let config = {
              headers : { 'X-Auth-Token' : JWT_TOKEN },
              params : { username : username}
          }
          const {data} = await axios.post(API_URL.access_chat_api,{},config)
        console.log("AC",data)
         
         if(!chats.find((c) => c._id === data.message._id))dispatch(setChats([data.message,...chats]))
         dispatch(setSelectedChat(data.message))
      } catch (error) {
          console.log(error)
      }
  }


    
    useEffect(() => {
      fetchChats()
      accessChat()
      viewTask()
      fetchAnswer()
      fetchUserID()
  }, [userId, id, username])

  const openDialog = () => setShowDialog(true)
  const closeDialog = () => setShowDialog(false)
  return (
    <>
    
      <AppBar className={classes.component}>
        <Toolbar className={classes.container}>
          <Link className={classes.link} to="/">
            {' '}
            <Typography>HOME</Typography>
          </Link>
          <Typography>ABOUT</Typography>
          <Typography>CONTACT</Typography>
        </Toolbar>
      </AppBar>

      <Box className={classes.box}>
        <img className={classes.image} src={image1} alt="" />
        <Box className={classes.titleBox}>
          <Typography className={classes.heading}>{question}</Typography>
          <Button
            /*style={{color:'green'}}*/ className={classes.button}
            variant="contained"
            onClick={openDialog}
          >
            Answer
          </Button>
         <Link to='/chats'>
            <Button  className={classes.button2}>
              Chat
            </Button>
            </Link>
        </Box>

        <Box className={classes.subheading}>
          <Typography>Author : {username}</Typography>
          <Typography>{new Date(date).toDateString()}</Typography>
        </Box>
        <hr />

        <Box></Box>
      </Box>
      {answers &&
        answers.map((a) => (
          <>
            {a.hasOwnProperty('task_verifier') && a.task_verifier && (
              <Box className={classes.box}>
                <Box className={classes.userDet}>
                  <Avatar></Avatar>
                  <Typography className={classes.username} style={{ color: '#a7a7a7' }}>
                    {a.username}
                  </Typography>
                </Box>

                <Typography>{a.task_answer}</Typography>
                <hr />
              </Box>
            )}
          </>
        ))}

      <Dialog open={showDialog} onClose={closeDialog} disableBackdropClick>
        <Box style={{ width: '500px', height: '500px' }}>
          <DialogTitle>Submit Answer</DialogTitle>
          <DialogContent dividers style={{ width: '500px', height: '370px' }}>
            <TextField
              type="message"
              placeholder="Enter answer here"
              variant="outlined"
              name="task_ans"
              value={task_ans}
              onChange={(e) => setTaskAns(e.target.value)}
              fullWidth
              multiline
              rows={15}
              required
            />
          </DialogContent>
          <DialogActions>
            <Button className={classes.button3} onClick={submitAns}>
              SUBMIT
            </Button>
            <Button className={classes.button4} onClick={closeDialog}>
              CANCEL
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  )
}

export default Info
